<template>
  <div
    id="autoplay_task_header"
    class="size-full flex items-center justify-between text-white"
  >
    <HeaderLeftSection />
    <HeaderRightSection />

    <CustomDraggableModal
      title="What to talk"
      v-model="showWhatToTalkModal"
      :size="16"
      :width="800"
      :initial-position="modalInitialPosition"
      :icon="imagePath.neutral.grey.draggableDots"
      alt="draggable_dots"
      header-padding="py-2 pr-2 pl-1"
      @position-change="handlePositionChange"
      v-if="!isWhatToTalkDisabled"
    >
      <div v-if="loading" class="p-4 text-center">
        <div>
          <div class="flex flex-row text-sm items-center">
            <ThemeImage
              :icon="imageNames.AGI_PURPLE"
              alt="agi_purple_icon"
              class="size-4 mr-1.5"
            />
            Generating...
          </div>
          <div class="loading_placeholder">
            <div class="loading_line custom_skeleton"></div>
            <div class="loading_line short custom_skeleton"></div>
          </div>
        </div>
      </div>
      <div v-else class="p-4 max-h-[60vh] overflow-y-auto">
        <MarkdownContent
          :markdownText="whatToTalkNotes"
          customClass="text-[15px]"
        />
      </div>
    </CustomDraggableModal>
  </div>
</template>

<script setup>
import { ref, provide, watch, computed } from "vue";
import { message } from "ant-design-vue";
import { bannerStatuses } from "@/src/constants/bannerConstants.js";
import store from "@/src/store/index.js";
import imagePath from "@/src/paths/imagePath.js";
import CustomDraggableModal from "@/src/components/CustomDraggableModal.vue";
import HeaderLeftSection from "@/src/components/autoplay_components/HeaderLeftSection.vue";
import HeaderRightSection from "@/src/components/autoplay_components/HeaderRightSection.vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import MarkdownContent from "@/src/components/MarkdownContent.vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
const showWhatToTalkModal = ref(false);
const whatToTalkNotes = ref("");
const modalPosition = ref({ x: 0, y: 0 });
const modalInitialPosition = ref({ x: 0, y: 0 });
const loading = ref(false);

const isWhatToTalkDisabled = computed(() => {
  return localStorage.getItem("sequences_remove_what_to_talk") === "true";
});

const openWhatToTalkModal = () => {
  if (isWhatToTalkDisabled.value) {
    return;
  }
  
  const width = 1440;
  const height = window.innerHeight;
  modalInitialPosition.value = {
    x: document.documentElement.clientWidth / 2 - width / 2,
    y: document.documentElement.clientHeight / 2 - height / 2,
  };
  showWhatToTalkModal.value = true;
};

const handlePositionChange = (position) => {
  modalPosition.value = position;
};

watch(showWhatToTalkModal, (newVal) => {
  if (!newVal) {
    whatToTalkNotes.value = "";
  }
});

provide("whatToTalk", {
  open: openWhatToTalkModal,
  showModal: showWhatToTalkModal,
  notes: whatToTalkNotes,
  loading: loading,
});

provide("store", store);
provide("showMessage", message);
provide("bannerStatuses", bannerStatuses);
</script>

<style scoped>
.custom-scroll-container {
  overflow-y: auto;
}

.loading_line {
  height: 16px;
  background-color: var(--white-opacity-6);
  border-radius: 4px;
}

.loading_line.short {
  width: 75%;
}

.loading_placeholder {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  margin-top: 10px;
}
</style>
